import { useNavigate } from '@tanstack/react-router';
import { AppShell } from '@tupai/shell';
import hello from '@tupai/tokens/assets/spot/hello.svg';
import { useTranslation } from '@tupai/i18n/react';

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('common');

  return (
    <AppShell
      variant="fullscreen"
      tone="surface"
      className="relative items-center justify-center overflow-y-auto px-8 py-8"
    >
      <div className="flex w-full max-w-sm flex-col items-center text-center">
        <img src={hello} alt="" className="mb-8 size-16 object-contain" />
        <h1 className="mb-4 font-display text-2xl text-content">{t('pageNotFound')}</h1>
        <p className="mb-8 text-base text-content">{t('pageNotFoundBody')}</p>
        {/* `/` sends signed-out parents on to /start. */}
        <button onClick={() => navigate({ to: '/', replace: true })} className="cta-primary w-full">
          {t('goHome')}
        </button>
      </div>
    </AppShell>
  );
}
